// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  base_url: 'https://madarv2-stage.madar.app/',
  cloudFlareUrl: 'https://api-stg.madloxbserapi.org/',
  socket_url: 'https://mobiletracking-test.madar.app/',
  api_version: 'v0.0.1',
  api_v2: 'v0.0.2',
  api_prefix: '/api/',
  google_map_key: 'AIzaSyD4cT14FheqMnb4RdZMou4z7SaCZVEv_1k',
  amplitudeApiKey: '',
  appApiKey: '9NX7SXeBXfUcek25v2385BiuresPYCUdnS4DwZ8dSUg8AKRNUg8WLVj2Ve86Yry7',
  paytabsKey: 'C6KMNN-KDHV6T-VQN6G7-PQGKTG',
  white_listed_Domains: [
    'localhost:4000',
    'localhost:3000',
    'localhost:4201',
    'madarv2-stage.madar.app',
    'madarv2-test-app-backend-micro-mobiletracking.azurewebsites.net',
    'api-stg.madloxbserapi.org',
  ],
  production: false,
  tgaHostNames: ['tga-stage.madar.app'],
  fleetHostNames: ['fleet-stage.madar.app'],
  zenDeskKey: null,
  encryptPasswordKey: 'nwtPzEg:Ev:E_9U#$-AE">=.UVhdkLd`',
  recaptchaV3SiteKey: '6LeytIwrAAAAAHXNKjHCNRx6WoApaULPDUL1OoP2',
  recaptchaV2SiteKey: '6LfDx08tAAAAAHBfzzOjdrmnKSZEJWVK2T8gy7ni',
  firebase: {
    apiKey: "AIzaSyA7tBkmXszRTQpL-Qb-upEpKdURtgpAEvE",
    authDomain: "madar-stage.firebaseapp.com",
    projectId: "madar-stage",
    storageBucket: "madar-stage.firebasestorage.app",
    messagingSenderId: "1079011738958",
    appId: "1:1079011738958:web:eca4c9307d61accda34a1f",
    measurementId: "G-91GBRXN03J"
  },
  launchDarklyClient: '68b3ffbce5f23509a92f784e',
  googleAnalytics: null,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
